// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"styles_infoBox_1tdzf7gzFzbcXRDE1yUxzJ"};